import React, { useContext } from "react";
import { ThemeContext } from "../../ThemeContext"; // adjust path if needed

import lightClasses from "./ForFooter.module.css";
import darkClasses from "./Darkfooter.module.css";
import logo from "../../Assets/dshbrdlogo.png";
import { Mail, Phone } from "lucide-react";

const ForFooter = () => {
  const { theme } = useContext(ThemeContext);
  const classes = theme === "dark" ? darkClasses : lightClasses;

  return (
    <footer className={classes.footer}>
      <div className={classes.topSection}>
        <div className={classes.leftContent}>
          <img src={logo} alt="Promix logo" className={classes.logo} />
          <p className={classes.description}>
            The future of accounting intelligence. Transform your financial
            operations with AI-powered automation and real-time insights.
          </p>
          <div className={classes.contact}>
            <div className={classes.contactItem}>
              <Mail className={classes.icon} />
              <span>hello@promix.com</span>
            </div>
            <div className={classes.contactItem}>
              <Phone className={classes.icon} />
              <span>+234 816 124 1827</span>
            </div>
          </div>
        </div>

        <div className={classes.linksSection}>
          <div className={classes.linkGroup}>
            <h4>Product</h4>
            <ul>
              <li>Features</li>
              <li>Integrations</li>
              <li>API</li>
              <li>Security</li>
              <li>Mobile App</li>
            </ul>
          </div>
          <div className={classes.linkGroup}>
            <h4>Company</h4>
            <ul>
              <li>About</li>
              <li>Careers</li>
              <li>Press</li>
              <li>Partners</li>
              <li>Contact</li>
            </ul>
          </div>
          <div className={classes.linkGroup}>
            <h4>Resources</h4>
            <ul>
              <li>Documentation</li>
              <li>Help Center</li>
              <li>Blog</li>
              <li>Webinars</li>
              <li>Community</li>
            </ul>
          </div>
        </div>
      </div>

      <div className={classes.bottomSection}>
        <p>© 2025 Promix. All rights reserved.</p>
        <div className={classes.legalLinks}>
          <span>Privacy</span>
          <span>Terms</span>
          <span>Cookies</span>
        </div>
      </div>
    </footer>
  );
};

export default ForFooter;
